import { jsxs as o, jsx as r } from "react/jsx-runtime";
import "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import i from "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import s from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import m from "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import { getFirstImage as c, getAddressDescription as l, getBathroomCount as d } from "@propify-tenant-client/common";
import { formatCurrency as g } from "@propify/components";
import e from "big.js";
const h = s({
  image: {
    height: "100px",
    width: "100%",
    textAlign: "center",
    margin: "auto"
  }
}), gt = ({ unit: t }) => {
  var p;
  const n = h(), a = (p = c(t.property.listingImages)) == null ? void 0 : p.thumbnailUrl;
  return /* @__PURE__ */ o(i, { container: !0, spacing: 1, style: { minWidth: "300px" }, children: [
    /* @__PURE__ */ r(i, { item: !0, xs: 5, children: /* @__PURE__ */ r("img", { title: "", alt: "", src: a, className: n.image }) }),
    /* @__PURE__ */ o(i, { item: !0, xs: 7, children: [
      /* @__PURE__ */ r(m, { variant: "caption", component: "p", color: "textPrimary", children: l(t.property.address) }),
      /* @__PURE__ */ r(
        m,
        {
          variant: "caption",
          component: "p",
          color: "textPrimary",
          style: { fontWeight: "bold" },
          children: g(e(t.listedRent || 0).round(0, e.roundUp), {
            noEmptyDecimals: !0
          })
        }
      ),
      /* @__PURE__ */ o(m, { variant: "caption", component: "p", color: "textSecondary", children: [
        "Beds: ",
        t.bedroomCount,
        " - Baths: ",
        d(t)
      ] })
    ] })
  ] });
};
export {
  gt as PointInMap
};
//# sourceMappingURL=PointInMap.js.map
